import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element, allowedRoles, userRole }) => {
  userRole = sessionStorage.getItem("role");
  if (allowedRoles.includes(userRole)) {
    return element;
  } else {
    // Redirect to a different route when the user doesn't have the required role
    return <Navigate to="/unauthorized" />;
  }
};

export default ProtectedRoute;
